<div class="template-layout">
  <div class="template-layout-header">
    <div class="template-layout-header--close">
      <button (click)="close()">
        <span class="wk-icon-close"></span>
      </button>
    </div>
    <h2 *ngIf="hasFolderId && hasTemplates">
      {{ 'APP.TEMPLATE_DOCUMENT.TITLE' | translate }}
    </h2>
  </div>
  <div class="template-layout-body">
    <ng-container *ngIf="isLoading">
      <div class="template-layout-body--loading-spinner">
        <mat-progress-spinner
          [color]="'primary'"
          [mode]="'indeterminate'"
          diameter="100"
        >
        </mat-progress-spinner>
      </div>
    </ng-container>
    <ng-container *ngIf="hasTemplates">
      <wk-select
        label="{{ 'APP.TEMPLATE_DOCUMENT.SELECT_TEMPLATE' | translate }}"
        show-required-indicator
      >
        <select
          class="wk-field-select"
          id="template-name-tooltip"
          [ngClass]="{'change-weight': !templateFormName }"
          [(ngModel)]="templateSelected"
          (ngModelChange)="selectTemplate()"
          required
        >
          <option [ngValue]="null" disabled>
            {{ 'APP.TEMPLATE_DOCUMENT.CHOOSE' | translate}}
          </option>
          <option
            title="{{ (template.title && template.title.trim()) || template.name | sentencecase }}"
            class="select-option"
            *ngFor="let template of templates"
            [ngValue]="template"
          >
            {{ (template.title && template.title.trim()) || template.name |
            templateName | sentencecase }}
          </option>
        </select>
      </wk-select>
      <wk-tooltip
        *ngIf="templateSelected && nameLonger()"
        type="description"
        position="right"
        target-selector="#template-name-tooltip"
      >
        <p slot="body">{{ templateSelected.name }}</p>
      </wk-tooltip>
    </ng-container>
    <ng-container *ngIf="templateFormName">
      <wk-forms
        [hideOnChange]="!hasFormLoaded"
        [mandatoryFieldsForRendering]="mandatoryFields"
        [templateForm]="templateForm"
        [showCompleteButton]="false"
        [showSaveButton]="false"
        [showRefreshButton]="false"
        [showTitle]="false"
        [showValidationIcon]="false"
        (formLoaded)="formLoaded($event)"
        (error)="handleError($event)"
      >
      </wk-forms>
    </ng-container>
    <ng-container *ngIf="!isLoading && hasFolderId && !hasTemplates">
      <div class="template-layout-body--error">
        {{ 'APP.TEMPLATE_DOCUMENT.NO_TEMPLATES' | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && !hasFolderId && !hasTemplates">
      <div class="template-layout-body--error">
        {{ 'APP.TEMPLATE_DOCUMENT.IMPROPER_PATH' | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && noTemplateFormShared">
      <div class="template-layout-body--error">
        {{ 'APP.TEMPLATE_DOCUMENT.NO_FORM_SHARED' | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading && errorMessage">
      <div class="template-layout-body--error">
        {{ errorMessage | translate }}
      </div>
    </ng-container>
  </div>
  <div *ngIf="hasFolderId && hasTemplates" class="template-layout-actions">
    <button class="wk-button wk-button-text" (click)="close()">
      {{ 'APP.TEMPLATE_DOCUMENT.CANCEL' | translate }}
    </button>
    <button
      class="wk-button"
      (click)="createHTMLFromTemplate()"
      [disabled]="!hasFormLoaded || !formModel?.isValid"
    >
      {{ 'APP.TEMPLATE_DOCUMENT.CREATE' | translate }}
    </button>
  </div>
</div>
